import React from 'react';
import { IoToday } from 'react-icons/io5';
import { MdOutlineTrendingDown, MdOutlineTrendingUp } from 'react-icons/md';

const YesterDayCard = ({ summ, convertSeconds }) => {
  return (
    <div className="col-6">
      <div className="card  m-b-20 enhanced-card">
        <div className="border_class d-flex justify-content-between align-items-center">
          <h5 className="dash-card-title font-20 ml-3">
            <IoToday className="mr-1 mb-1 font-18 dash-text-primary" />{' '}
            Yesterday
          </h5>
          <h5
            className={
              summ?.yesterdayActivitySummary?.percentageChange > 0
                ? 'text-success mr-2'
                : 'text-danger mr-2'
            }
            style={{ fontSize: '2rem' }}
          >
            {summ?.yesterdayActivitySummary?.percentageChange > 0 ? (
              <MdOutlineTrendingUp />
            ) : (
              <MdOutlineTrendingDown />
            )}
          </h5>
        </div>
        <div className="card-body dash_cards">
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-3 fonts_size">
              <p
                className={
                  summ?.yesterdayActivitySummary?.percentageChange > 0
                    ? 'mr-1 text-success'
                    : 'mr-1 text-danger'
                }
              >
                {summ?.yesterdayActivitySummary?.percentageChange?.toFixed(2) +
                  '%'}{' '}
              </p>{' '}
              <span>the day before</span>
              <p className="ml-1 text_style">
                {convertSeconds(summ?.yesterdayActivitySummary?.previousTime)}
              </p>
            </div>
            <span className="font-16 time_border mb-1">
              {convertSeconds(summ?.yesterdayActivitySummary?.time)}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text_light font-15 d-flex align-items-center">
              Active Members{' '}
              <h6 className="ml-2">
                {summ?.yesterdayActivitySummary?.activeMembers}
              </h6>
            </span>

            <span className="text_light font-15 d-flex align-items-center">
              Active Projects{' '}
              <h6 className="ml-2">
                {summ?.yesterdayActivitySummary?.activeProjects}
              </h6>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YesterDayCard;
